export enum DialogThemes {
  Info = 'info',
  Alert = 'alert',
  Confirm = 'confirm',
}
